export default "__VITE_ASSET__SUhR0WY6__"